<template>
  <div class="cart" @touchmove.prevent>
    <div class="title">{{ $t('pecenter.cart') }} ({{ productNum }})</div>
    <div class="cart-content">
      <NoData v-if="!list.length" />
      <div v-else class="cart-list">
        <div class="cart-item" v-for="item in list" :key="item.id">
          <img class="item-caption" :src="item.goodsImg || require('@/assets/images/common/default-good-img.svg')" />
          <div class="item-info">
            <div class="item-title">
              {{ item.goodsName }}
            </div>
            <div class="item-type">
              {{ item.goodsAttr }}
            </div>

            <div class="item-price">
              {{ userStore.currency }}
              {{ userStore.currencyUnit }}
              {{ $flatRateOrigin(item.writePrice, userStore.rate) }}
            </div>

            <div class="del-icon">
              <el-icon @click.stop="delProduct(item)">
                <Delete />
              </el-icon>
            </div>
            <el-input-number class="num-input" size="small" v-model="item.goodsNum" :min="1" :step="1"
              :max="item.quantity" @change="changeProductNum(item)" />
          </div>
        </div>
      </div>
    </div>
    <div class="cart-footer">
      <div class="price">
        {{ $t('cart.moreView') }}
        <!-- <span class="num"
          >{{ userStore.currencyUnit }}
          {{ $flatRateOrigin(totalMoney, userStore.rate) }}</span
        > -->
      </div>
      <el-button type="primary" class="go-cart" @click="goToCart">{{
        $t('cart.goCartPay')
        }}</el-button>
    </div>
  </div>
</template>

<script setup>
import NoData from '@/components/NoData'
import { useCartStore, useUserStore } from '@/stores'
import { ElMessageBox } from 'element-plus'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

// const $props = defineProps({
//   pageLoading: {
//     type: Function,
//   },
// })

const { t } = useI18n()
const cartStore = useCartStore()
const userStore = useUserStore()
const list = computed(() => {
  return cartStore.list.reduce((acc, item) => {
    let arr1 = item.goods.map((it) => ({ ...it, shopIds: item.id }))
    let arr2 = acc.concat([...arr1])
    if (arr2.length > 4) {
      return arr2.slice(0, 4)
    } else {
      return arr2
    }
  }, [])
})
const $router = useRouter()
const productNum = computed(() => {
  return userStore.isLogin ? cartStore.productNum : 0
})

// const totalMoney = computed(() => {
//   return list.value
//     .reduce((acc, item) => {
//       return acc.add(Decimal(item.goodsNum).mul(Decimal(item.writePrice)));
//     }, Decimal(0))
//     .toNumber();
// });
// 删除商品
const delProduct = (productInfo) => {
  // const close = $props.pageLoading()
  ElMessageBox.confirm(t('cart.delConfirmProduct'), t('cart.hint'), {
    confirmButtonText: t('cart.confirm'),
    cancelButtonText: t('cart.cancel'),
    type: 'warning',
    center: true,
  })
    .then(async () => {
      const params = {
        userId: userStore.profile.id,
        storeNos: [productInfo.shopIds],
        goodsIds: [productInfo.id],
      }
      await cartStore.removeCartData(params)
    })
    .finally(() => {
      // close()
    })
}
const changeProductNum = async (item) => {
  if (!item.goodsNum) return
  // const stopLoading = $props.pageLoading()
  const params = {
    goodsNum: item.goodsNum,
    userId: userStore.profile.id,
    goodsId: item.goodsId,
    skuId: item.skuId,
    id: item.id,
  }
  try {
    let res = await cartStore.updateCartProductNum(item, params)
    console.log('res:', res)
  } catch (error) {
    console.log('res:', error)
  } finally {
    // stopLoading()
  }

  // stopLoading()
}
const goToCart = () => {
  $router.push({ name: 'cart' })
}
</script>

<style lang="scss" scoped>
.cart {
  width: 360px;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 10px;

  .title {
    width: 360px;
    font-family: Montserrat;
    font-size: 16px;
    color: var(--black-common-color-6);
  }

  .cart-content {
    width: 360px;
    margin-top: 20px;

    .cart-item {
      width: 360px;
      height: 100px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;

      &:hover {
        .del-icon {
          display: block;
        }
      }

      .item-caption {
        width: 100px;
        height: 100px;
        border-radius: 4px;
        margin-bottom: 7px;
      }

      .item-info {
        width: 240px;
        position: relative;
        text-align: left;

        .item-title {
          width: 240px;
          font-family: Montserrat;
          font-size: 14px;
          color: var(--black-common-color-9);
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }

        .item-type {
          width: 240px;
          margin-top: 12px;
          margin-bottom: 18px;
          font-family: Montserrat;
          font-size: 12px;
          white-space: nowrap;
          color: var(--black-color-4-light);
          overflow: hidden;
          text-overflow: ellipsis;
          color: rgb(153, 153, 153);
        }

        .item-price {
          font-family: Montserrat;
          font-size: 14px;
          font-weight: bold;
          color: var(--primary-color);
        }

        .del-icon {
          position: absolute;
          right: 0px;
          bottom: 42px;
          width: 12px;
          cursor: pointer;
        }
      }
    }

    .num-input {
      position: absolute;
      right: 02px;
      bottom: 0px;
      height: 25px;
    }

    ::v-deep(.num-input) {
      .el-input__wrapper {
        height: 25px;
      }
    }
  }

  .cart-footer {
    width: 100%;

    .price {
      text-align: center;
      color: var(--black-color-26);
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 12px;
      margin-top: 20px;

      .num {
        font-weight: 700;
        font-size: 18px;
        color: #333;
      }
    }

    .go-cart {
      width: 360px;
      height: 36px;
      border-radius: 8px;
      background-color: var(--primary-color);
    }

    ::v-deep {
      .el-button {
        width: 100%;
      }
    }
  }
}
</style>
